module.exports = __webpack_public_path__ + "static/img/QY.12b14ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QY.png
// module id = DzH9
// module chunks = 18